module.exports = __webpack_public_path__ + "static/media/icon_saw.e3dbb6db.svg";